import React from 'react'
import { useWebSocket } from '../../context/WebSocketProvider'
import { UserDiv, Wrapper, MessageDiv } from './MessageBox.styles'

export const MessageBox = ({}) => {
  
  const {onlineUsers} = useWebSocket()

  console.log(onlineUsers)
  
  return (
<>
    <div>Users</div>

<Wrapper>
{onlineUsers?.map((user)=>(
      <>
    
      <UserDiv status={user.onlineStatus}>

      <div>{user.username}</div>
      <div>{user.onlineStatus? "Online":"Offline"}</div>

      </UserDiv>

    </>
    )

    )}


</Wrapper>


    
    {/* {messages.map((message)=>(


      <>
      
      <MessageDiv>
      <div>{message.sender}</div>:
      <div>{message.message}</div>

      </MessageDiv>

      
      </>
    ))} */}

   
      
    
    </>
  )
}
